// extracted by mini-css-extract-plugin
module.exports = {"links":"links_links__u3303","title":"links_title__sO6Yo","link":"links_link__WyVUR"};